export function tenantRetention(rent: number, rate: number, agent: boolean): number {
  return agent ? Math.round(rent * rate) / 100 : 0;
}
